module.exports = __webpack_public_path__ + "img/77.15ae1faa.jpg";